export default "__VITE_ASSET__883ded96__"